import './App.css';
import headImg from './head.png';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/Dashboard/Dashboard';

function HomePage() {
  return (
    <div className="main-content">
      <img src={headImg} className="head-image" alt="UMAN head" />
      <h1 className="title">UMAN</h1>
      <p className="tagline">Show the World You're Real — Especially on Socials</p>
      <p className="availability">Available only on world.</p>
      <div className="nav-buttons">
        <Link to="/dashboard" className="dashboard-button">View Statistics Dashboard</Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">UMAN</Link>
            <div className="nav-links">
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/dashboard" className="nav-link">Dashboard</Link>
            </div>
          </div>
        </nav>
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
        
        <footer className="footer">
          <p>Thank you to Vercel for sponsoring</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
